import { Controller } from 'react-hook-form';
import { Input } from '@Components/common/FormUI';
import { FormFieldProps } from '@Constants/interface/FormInterface';
import { UseFormPropsType } from '@Constants/Types/type';
import DropDown from '@Components/common/DropDown';
import { IDropDownData } from '@Constants/interface';
import FileUpload from '@Components/common/FormUI/Upload';
import Textarea from '@Components/RadixComponents/TextArea';
import Checkbox from '@Components/common/FormUI/CheckBox';
import RadioButton from '@Components/common/FormUI/Radio';
import DropdownAccordion from '@Components/common/DropdownAccordion';
import TiptapEditor from '@Components/common/FormUI/TipTapEditor';
import PasswordInput from '@Components/common/FormUI/PasswordInput';
import NativeDatePicker from '@Components/common/FormUI/NativeDatePicker/SingleDatePicker';
import MonthYearDatePicker from '@Components/common/FormUI/MonthYearDatePicker';

export default function getInputElement(
  data: FormFieldProps,
  formProps: UseFormPropsType,
  dropdownOptions?: IDropDownData[],
) {
  const {
    id,
    type,
    placeholder,
    inputType,
    multiple,
    fileAccept,
    className,
    readOnly,
    choose,
    hasLeftIcon,
    leftIconName,
    // disabledDays,
    maxSize,
    isValueNumber = false,
    checkBox,
    disabled,
    subGroupName,
    enableSearchBar,
    enableSingleParent,
    enableSearchbar,
    editable = true,
    parentName,
    childName,
    selectSingleChild,
  } = data;
  const { register, control, getValues } = formProps;

  switch (type) {
    case 'input':
      return (
        <Input
          type={inputType || 'text'}
          placeholder={placeholder}
          className={className}
          {...register(`${id}`, { valueAsNumber: isValueNumber })}
          readOnly={!!readOnly}
          disabled={disabled}
          autoComplete="off"
        />
      );
    case 'textArea':
      return (
        <Textarea
          placeholder={placeholder}
          className={className}
          readOnly={!!readOnly}
          {...register(`${id}`, {})}
        />
      );
    case 'select':
      return (
        <Controller
          control={control}
          name={id}
          defaultValue=""
          render={({ field: { value, onChange } }) => (
            <DropDown
              placeholder={placeholder}
              className="naxatw-w-full"
              options={dropdownOptions || []}
              value={value}
              onChange={onChange}
              choose={choose}
              hasLeftIcon={hasLeftIcon}
              leftIconName={leftIconName}
              multiple={multiple}
              checkBox={checkBox}
              disabled={disabled}
              enableSearchbar={enableSearchbar}
            />
          )}
        />
      );

    case 'file-upload':
      return (
        <Controller
          control={control}
          name={id}
          render={({ field: { value, onChange } }) => {
            return (
              <FileUpload
                placeholder={placeholder}
                multiple={!!multiple}
                name={id}
                data={value}
                fileAccept={fileAccept}
                onChange={() => onChange(getValues?.()?.[data.id])}
                maxSize={maxSize}
                {...formProps}
              />
            );
          }}
        />
      );

    case 'datePicker':
      return (
        <Controller
          control={control}
          name={id}
          defaultValue=""
          render={({ field: { value, onChange } }) => (
            <NativeDatePicker onChange={onChange} value={value} />
          )}
        />
      );
    // return (
    //   <Controller
    //     control={control}
    //     name={id}
    //     defaultValue=""
    //     render={({ field: { value, onChange } }) => (
    //       <DatePicker
    //         date={value}
    //         onChange={onChange}
    //         disabledDays={disabledDays}
    //       />
    //     )}
    //   />
    // );
    case 'checkBox':
      return (
        <Controller
          control={control}
          name={id}
          defaultValue=""
          render={({ field: { value, onChange } }) => (
            <Checkbox value={value} onChange={onChange} label={id} />
          )}
        />
      );
    case 'radio':
      return (
        <Controller
          control={control}
          name={id}
          defaultValue=""
          render={({ field: { value, onChange } }) => (
            <RadioButton
              onChangeData={onChange}
              options={dropdownOptions || []}
              value={value}
            />
          )}
        />
      );

    case 'accordion-select':
      return (
        <Controller
          control={control}
          name={id}
          defaultValue=""
          render={({ field: { value, onChange } }) => (
            <DropdownAccordion
              checkedItems={value}
              onCheckboxChange={(newCheckedItems: Record<string, any>) =>
                onChange(newCheckedItems)
              }
              options={dropdownOptions || []}
              enableSearchBar={enableSearchBar}
              subGroupName={subGroupName}
              placeholder={placeholder}
              enableSingleParent={enableSingleParent}
              parentName={parentName}
              childName={childName}
              selectSingleChild={selectSingleChild}
              multiple={multiple}
            />
          )}
        />
      );
    case 'tiptap-editor':
      return (
        <Controller
          control={control}
          name={id}
          render={({ field: { value, onChange } }) => {
            return (
              <TiptapEditor
                bindvalue={value}
                editable={editable}
                onChange={onChange}
              />
            );
          }}
        />
      );
    case 'password-input':
      return (
        <PasswordInput
          placeholder={placeholder}
          className={className}
          disabled={disabled}
          autoComplete="off"
          {...register(`${id}`, { valueAsNumber: isValueNumber })}
        />
      );

    case 'monthYearDatePicker':
      return (
        <Controller
          control={control}
          name={id}
          defaultValue=""
          render={({ field: { value, onChange } }) => (
            <MonthYearDatePicker onChange={onChange} date={value} />
          )}
        />
      );

    default:
      return '';
  }
}
